/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsArrowUp: {
  name: 'arrow-up';
  data: string;
} = {
  name: 'arrow-up',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M8 15.5a.5.5 0 0 0 .5-.5V2.207l4.146 4.147a.5.5 0 0 0 .708-.708l-5-5a.5.5 0 0 0-.708 0l-5 5a.5.5 0 1 0 .708.708L7.5 2.207V15a.5.5 0 0 0 .5.5Z" fill="currentColor"/></svg>`,
};
